import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsComponent } from './news.component';
import { NewsRoutingModule } from './news-routing.module';
import { MaterialModule } from 'src/app/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {ClipboardModule} from '@angular/cdk/clipboard';

@NgModule({
  imports: [
    CommonModule,
    NewsRoutingModule,
    MaterialModule,
    FlexLayoutModule,
    MatSnackBarModule,
    ClipboardModule
  ],
  declarations: [NewsComponent]
})
export class NewsModule { }
